
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 768 1024"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M93.091 139.638c0-25.706 20.839-46.545 46.545-46.545H605.09c25.708 0 46.546 20.839 46.546 46.545v744.728c0 25.705-20.838 46.544-46.546 46.544H139.636c-25.706 0-46.545-20.838-46.545-46.544V139.638zM139.636.002C62.517.002 0 62.519 0 139.638v744.728c0 77.119 62.517 139.637 139.636 139.637H605.09c77.119 0 139.637-62.518 139.637-139.637V139.638C744.727 62.519 682.209.002 605.09.002H139.636zM372.363 744.73c-25.705 0-46.546 20.838-46.546 46.544 0 25.708 20.841 46.546 46.546 46.546h.466c25.705 0 46.544-20.838 46.544-46.546 0-25.705-20.838-46.544-46.544-46.544h-.466z"}})])
          )
        }
      }
    